// extracted by mini-css-extract-plugin
export default {"loading-screen":"Tp_Fe","loadingScreen":"Tp_Fe","text":"Z79zi"};